<script setup lang="ts">
import { IconNames } from '~/enums'
</script>

<template>
  <UModal :dismissible="false" :close="false" :ui="{ header: 'p-0 sm:px-0 min-h-0' }">
    <template #header>
      <span class="invisible" />
    </template>
    <template #body>
      <div class="space-y-4 text-center">
        <UIcon :name="IconNames.settings_02" class="text-primary size-8 animate-spin" />
        <h4 class="text-lg sm:text-xl lg:text-2xl text-highlighted font-bold">
          {{ $t("profile-switcher.loading-modal.title") }}
        </h4>
        <p class="text-sm sm:text-base text-toned">
          {{ $t("profile-switcher.loading-modal.description") }}
        </p>
      </div>
    </template>
  </UModal>
</template>
